import { WHATSAPP_ITEM_KIND } from './constants';
import { WhatsAppTimelineItem } from './types';

/** Tie-break at equal time: the person's message, then their file, then Meera's reply, then id (matches babler's TIMELINE_ORDER). */
const KIND_ORDER = { [WHATSAPP_ITEM_KIND.IN]: 0, [WHATSAPP_ITEM_KIND.FILE]: 1, [WHATSAPP_ITEM_KIND.OUT]: 2 } as const;

const compareItems = (a: WhatsAppTimelineItem, b: WhatsAppTimelineItem): number =>
    Date.parse(a.at) - Date.parse(b.at) ||
    KIND_ORDER[a.kind] - KIND_ORDER[b.kind] ||
    (a.file?.n ?? 0) - (b.file?.n ?? 0) ||
    (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);

/**
 * Merges loaded items with a newly fetched page: dedupes by id (incoming wins) and RE-SORTS
 * everything — never a plain prepend, because a person's message can carry a timestamp
 * earlier than its page's lower bound.
 */
export const mergeTimelineItems = (existing: WhatsAppTimelineItem[], incoming: WhatsAppTimelineItem[]): WhatsAppTimelineItem[] => {
    const byId = new Map<string, WhatsAppTimelineItem>();
    [...existing, ...incoming].forEach((item) => byId.set(item.id, item));
    return Array.from(byId.values()).sort(compareItems);
};
